import { Link, Outlet, useNavigate, useSearchParams } from "react-router-dom";
import {
  ArrowLeft,
  BarChart3,
  Building2,
  GraduationCap,
  LayoutGrid,
  MapPin,
  School,
  ShieldAlert,
  Target,
  Users,
} from "lucide-react";
import { NIPUN_NAV_ITEMS } from "@/components/nipun/nipunConstants";
import SidebarUserCard from "@/components/SidebarUserCard";
import "../pages/NipunDashboard.css";
import "../styles/sqafSidebarShell.css";

const SIDEBAR_ICONS = {
  executive: BarChart3,
  state: LayoutGrid,
  district: MapPin,
  block: Users,
  super: GraduationCap,
  risk: ShieldAlert,
  school: School,
  governance: Building2,
};

const StandaloneNipunLayout = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "executive";

  const handleLogout = () => {
    if (onLogout) onLogout();
    navigate("/login");
  };

  const goToTab = (tabId) => {
    const next = new URLSearchParams(searchParams);
    if (tabId === "executive") next.delete("tab");
    else next.set("tab", tabId);
    navigate({ pathname: "/nipun-dashboard", search: next.toString() ? `?${next.toString()}` : "" });
  };

  return (
    <div className="nipun-dashboard-root">
      <div className="app-shell">
        <aside className="sq-sidebar" aria-label="NIPUN dashboard sidebar">
          <div className="sq-sidebar-brand">
            <Link className="sq-sidebar-brand-main" to="/" style={{ textDecoration: "none", color: "inherit" }}>
              <span className="sq-brand-icon" aria-hidden="true">
                <Target strokeWidth={2} width={22} height={22} />
              </span>
              <span className="sq-brand-copy">
                <strong>MH Education</strong>
                <span>NIPUN & Super Schools</span>
              </span>
            </Link>
          </div>

          <div className="sq-sidebar-scroll">
            <section className="sq-sidebar-section">
              <div className="sq-section-title">Visual Dashboards</div>
              <nav className="sq-nav">
                {NIPUN_NAV_ITEMS.map(({ id, label }) => {
                  const Icon = SIDEBAR_ICONS[id] || BarChart3;
                  return (
                    <button
                      key={id}
                      type="button"
                      className={`sq-nav-item${activeTab === id ? " active" : ""}`}
                      onClick={() => goToTab(id)}
                    >
                      <Icon strokeWidth={2} />
                      {label}
                    </button>
                  );
                })}
              </nav>
            </section>
          </div>

          <div className="sq-sidebar-footer">
            <SidebarUserCard user={user} onLogout={handleLogout} />
          </div>
        </aside>

        <main className="main">
          <header className="topbar">
            <div className="topbar-inner">
              <div className="breadcrumb">
                <Link to="/">Maharashtra</Link>
                <span>›</span>
                <b>NIPUN Dashboard</b>
              </div>
              <div className="top-actions">
                <span className="chip">
                  Year <b>2025–26</b>
                </span>
                <span className="chip">
                  Scope <b>State</b>
                </span>
                <span className="chip">
                  View <b>Visual</b>
                </span>
                <Link to="/" className="chip" title="Back to landing" style={{ display: "inline-flex" }}>
                  <ArrowLeft strokeWidth={2} width={16} height={16} />
                </Link>
              </div>
            </div>
          </header>
          <Outlet context={{ user, activeTab }} />
        </main>
      </div>
    </div>
  );
};

export default StandaloneNipunLayout;
